export const GET_movements = ({ movements }, getters, rootState) => {
  let movements_list = []
  let reciever_entity = []
  let assets_list = rootState.assets.assets
  let acquisitions_list = rootState.acquisitions.acquisitions

  for (let index = 0; index < movements.length; index++) {
    movements_list[index] = { ...movements[index] }
    assets_list.map((asset) => {
      if (asset.id == movements[index].asset_id) {
        movements_list[index].asset_number = asset.asset_number.toString()
        acquisitions_list.map((acquisition) => {
          if (acquisition.id == asset.acquisition_id) {
            movements_list[index].owner_entity = acquisition.owner_entity
            movements_list[index].description = acquisition.description
          }
        })
      }
    })

    reciever_entity = rootState.entities.entities.filter((entity) => {
      return entity.id === movements_list[index].reciever_entity_id
    })
    movements_list[index].reciever_entity = reciever_entity[0].name

    // const [year, month, day] = movements_list[index].movement_date.split('-')
    // movements_list[index].formated_movement_date = `${day}/${month}/${year}`

    movements_list[index].movement_document_number = movements_list[
      index
    ].movement_document_number.toString()
  }
  return movements_list
}

export const GET_specifyMovement = (state, getters) => (movement_id) => {
  let movements_array = getters.GET_movements
  return movements_array.filter((movement) => {
    return movement.id === movement_id
  })
}
